import { lazy } from 'react'
import type { RouteObject } from 'react-router-dom'

const ESGHubPage = lazy(() =>
  import('../pages/esg').then((m) => ({ default: m.ESGHubPage }))
)
const CSRDPage = lazy(() =>
  import('../pages/esg').then((m) => ({ default: m.CSRDPage }))
)
const CarbonPage = lazy(() =>
  import('../pages/esg').then((m) => ({ default: m.CarbonPage }))
)
const ESGKPIsPage = lazy(() =>
  import('../pages/esg').then((m) => ({ default: m.ESGKPIsPage }))
)
const DoubleMaterialityPage = lazy(() =>
  import('../pages/esg').then((m) => ({ default: m.DoubleMaterialityPage }))
)
const ESGReportingPage = lazy(() =>
  import('../pages/esg').then((m) => ({ default: m.ESGReportingPage }))
)
const GHGEmissionsPage = lazy(() =>
  import('../pages/esg').then((m) => ({ default: m.GHGEmissionsPage }))
)
const ESGSupplyChainPage = lazy(() =>
  import('../pages/esg').then((m) => ({ default: m.ESGSupplyChainPage }))
)

export const esgRoutes: RouteObject[] = [
  {
    path: '/esg',
    children: [
      { index: true, element: <ESGHubPage /> },
      { path: 'hub', element: <ESGHubPage /> },
      { path: 'csrd', element: <CSRDPage /> },
      { path: 'carbon', element: <CarbonPage /> },
      { path: 'kpis', element: <ESGKPIsPage /> },
      { path: 'double-materiality', element: <DoubleMaterialityPage /> },
      { path: 'reporting', element: <ESGReportingPage /> },
      { path: 'ghg-emissions', element: <GHGEmissionsPage /> },
      { path: 'supply-chain', element: <ESGSupplyChainPage /> },
    ],
  },
]
